import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, Button,
} from 'reactstrap';
import AvatarEditor from 'react-avatar-editor';

function ImageCropper(props) {
  const {
    isOpen, onClose, image, savedCroppedImage, width, height
  } = props;

  const [modal, setModal] = useState(isOpen);
  const [scale, setScale] = useState(1);
  const [allowZoomOut] = useState(false);
  const [editorRef, setEditorRef] = useState();
  const toggle = () => {
    setModal(!modal);
    onClose();
  };

  const saveCroppedImage = () => {
    toggle();
    const img = editorRef.getImageScaledToCanvas().toDataURL();
    savedCroppedImage(img);
  };

  const hideModal = () => {
    toggle();
    props.onClose();
  };

  const isClientLogo = props.isClientLogo;
  let stylesObj = {};
  if(isClientLogo) {
    stylesObj = {width:'530px'}
  }
  
  return (
    <Modal isOpen={modal} className={`modal-cropper ${width && 'cropper-lg'}`} style={stylesObj}>
      <ModalBody>
        <AvatarEditor
          ref={setEditorRef}
          image={image}
          scale={parseFloat(scale)}
          borderRadius={0}
          border={0}
          width={width || 600}
          height={height || 600}
          color={[255, 255, 255, 0.5]}
        />
        <div className="d-flex justify-content-between align-items-center mt-2">
          <input
            name="scale"
            type="range"
            onChange={(e) => setScale(parseFloat(e.target.value))}
            min={allowZoomOut ? '0.1' : '1'}
            max="2"
            step="0.01"
            defaultValue="1"
            className="range-slider"
          />
          <div className="crop-btn-group">
            <Button
              color="secondary"
              size="xs"
              className="mr-2"
              onClick={hideModal}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              size="sm"
              onClick={saveCroppedImage}
            >
              Save
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
ImageCropper.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  image: PropTypes.any.isRequired,
  savedCroppedImage: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
};
export default ImageCropper;
